module.exports = __webpack_public_path__ + "frontend/img/ubs_logo.9f6a0723.svg";